var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDividerCapLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 11H11V21H13V11H16L12 7L8 11ZM4 3V5H20V3H4Z",
    className: "selected",
    transform: "rotate(-90 12.000000000000002,12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerCapLeft);
export default __webpack_public_path__ + "static/media/divider_cap_left.1f32fdccaad72294f3c718bc863b93cc.svg";
export { ForwardRef as ReactComponent };